import { useState } from "react";
import { withTranslation } from "next-i18next";
import useFlash from "@hooks/use-flash";
import { useDeleteCartItem, useReloadPendingCart } from "@hooks/use-cart";
import Button from "@components/core/Button";
import translateVariantSize from "@utils/translateVariantSize";
import ProductPriceSection from "../Product/Shared/ProductPriceSection";
import CartImageLink from "./CartImageLink";

const CartItem = ({ cartItem, isCartItemRemovable, t }) => {
  const [loading, setLoading] = useState(false);

  const addFlash = useFlash();
  const deleteCartItem = useDeleteCartItem();
  const reloadPendingCart = useReloadPendingCart();

  const { product, size } = cartItem.variant;

  async function removeFromCart(cartItemId) {
    try {
      setLoading(true);
      await deleteCartItem(cartItemId);
    } catch (err) {
      reloadPendingCart();
      addFlash(t("common:cart_modal.error_on_delete_cart_item"), { variant: "danger" }, true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="d-flex justify-content-start" data-testid="cart-item">
      <CartImageLink product={product} />
      <div className="ps-3 py-3">
        <h6 className="mb-1">{product.name}</h6>
        <p className="mb-1 font-size-sm">{product.brand.name}</p>
        <p className="mb-2 font-size-sm">
          {t("common:variant_size", { size: translateVariantSize(size?.type, size?.value, t) })}
        </p>
        <ProductPriceSection product={product} className="mb-2" hideDiscountPercent />

        {isCartItemRemovable && (
          <Button
            variant="link-primary no-underline"
            onClick={() => removeFromCart(cartItem.id)}
            size="sm"
            loading={loading}
          >
            {t("common:cart_modal.remove")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default withTranslation("common")(CartItem);
